import React, { FC, memo } from 'react'
import { PhoneSpecs } from '../../phones'
import { ScenarioType, Steps } from '../../state/interfaces'
import { addAnswer, selectFilteredPhones, selectScenario, useDispatch, useSelector } from '../../state'
import { SortedPhoneList } from './sorted-phone-list'
import { PhoneList } from './phone-list'

export const FilteredPhoneList: FC = memo(() => {
  const phones = useSelector(selectFilteredPhones)
  const scenario = useSelector(selectScenario)
  const dispatch = useDispatch()

  const onClick = (phoneModelId: PhoneSpecs['modelId']) => {
    if (
      scenario &&
      (scenario.type === ScenarioType.MOBILE_SEARCH_EMAIL ||
        scenario.type === ScenarioType.MOBILE_ALERT ||
        scenario.id === 'mobile-d')
    ) {
      dispatch(addAnswer({ stepId: Steps.PHONE_MODEL_ID, answerIds: [phoneModelId.toString()], hidden: false }))
    } else {
      dispatch(addAnswer({ stepId: Steps.PHONE_MODEL_ID, answerIds: [phoneModelId.toString()], hidden: true }))
    }
  }

  return <SortedPhoneList PhoneList={PhoneList} phones={phones} onClick={onClick} />
})
